import axios from "axios";
import { baseUrl } from "../config/constants";

// RM-3943: requests Riivet sends a client account (owl Api::V1::ActionItemsController
// and Api::V1::ActionItemLinksController).

export type TActionItemStatus =
  | "open"
  | "client_done"
  | "verified"
  | "cancelled";
export type TWaitingOn = "client" | "riivet" | null;

export interface IActionItemActor {
  id?: number;
  name?: string | null;
  email?: string;
}

export interface IActionItemSubject {
  type: "Account" | "Domain" | "DomainApp";
  id?: number;
  label: string | null;
}

export interface IActionItem {
  id: number;
  status: TActionItemStatus;
  waiting_on: TWaitingOn;
  title: string;
  instructions: string | null;
  action_url: string | null;
  who_must_act: string | null;
  subject: IActionItemSubject | null;
  due_at: string | null;
  overdue: boolean;
  can_complete: boolean;
  rejection_note: string | null;
  client_done_by: IActionItemActor | null;
  created_at: string;
  client_done_at: string | null;
  verified_at: string | null;
}

export interface IActionItemEvent {
  from_status: TActionItemStatus | null;
  to_status: TActionItemStatus;
  note: string | null;
  actor: IActionItemActor | null;
  created_at: string;
}

export interface IActionItemDetail extends IActionItem {
  events: IActionItemEvent[];
}

// What the emailed no-login link shows: no history, no other people.
export interface IActionItemLink {
  status: TActionItemStatus;
  waiting_on: TWaitingOn;
  title: string;
  instructions: string | null;
  action_url: string | null;
  who_must_act: string | null;
  account: { name: string };
  subject: IActionItemSubject | null;
  email: string;
  due_at: string | null;
  rejection_note: string | null;
  client_done_at: string | null;
  can_complete: boolean;
}

export default {
  // Items the current user can see on the selected account (Account header).
  list: async (history = false): Promise<IActionItem[]> => {
    const res = await axios.get(`${baseUrl}/action_items`, {
      params: history ? { status: "all" } : {},
    });
    return res.data.action_items;
  },
  get: async (id: number): Promise<IActionItemDetail> => {
    const res = await axios.get(`${baseUrl}/action_items/${id}`);
    return res.data;
  },
  // Open items waiting on the user across their accounts (header badge).
  count: async (): Promise<{
    total: number;
    by_account: Record<string, number>;
  }> => {
    const res = await axios.get(`${baseUrl}/action_items/count`);
    return res.data;
  },
  markDone: async (id: number, note?: string): Promise<IActionItemDetail> => {
    const res = await axios.post(`${baseUrl}/action_items/${id}/done`, {
      note,
    });
    return res.data;
  },
  // The token goes in the body, never the URL: owl keeps paths in its logs.
  lookupLink: async (token: string): Promise<IActionItemLink> => {
    const res = await axios.post(`${baseUrl}/action_item_links/lookup`, {
      token,
    });
    return res.data;
  },
  markLinkDone: async (
    token: string,
    note?: string
  ): Promise<IActionItemLink> => {
    const res = await axios.post(`${baseUrl}/action_item_links/done`, {
      token,
      note,
    });
    return res.data;
  },
};
